import { getSessionJWT } from "@/infra/auth/helper";
import { getZaniaSocket } from "@/infra/sockets";
import { AgentSessionType } from "@/modules/sessions/types";
import { getAgentData } from "../states";
import { AGENT_TYPES, AgentData, GapAssessmentTypes, MultiVendorAssessmentTypes, QuestionnaireTypes, RiskAssessmentTypes } from "../types";
import { AgentSocketEvents } from "../types/events";
import { VendorRiskSectionEnum } from "../types/vendorAssessment";

export const getAgentTask = (
  agentData: AgentData<
    AGENT_TYPES,
    | RiskAssessmentTypes
    | GapAssessmentTypes
    | QuestionnaireTypes
    | MultiVendorAssessmentTypes
  >
): string => {
  const { agentType, sessionData, subType } = agentData;

  switch (agentType) {
    case AGENT_TYPES.GAP_ASSESSMENT:
      switch (sessionData.type) {
        case AgentSessionType.SOC2_GAP_TYPE1:
          return 'soc2_type1';
        case AgentSessionType.SOC2_GAP_TYPE2:
          return 'soc2_type2';
        default:
          return 'soc2_type2_audit';
      }

    case AGENT_TYPES.MULTI_FILE_VENDOR_ASSESSMENT:
      return 'multi_file_vendor_assessment';

    case AGENT_TYPES.RISK_ASSESSMENT:
			if(subType  === RiskAssessmentTypes.FAIR){
				return 'fair_ra';
			}
      if (sessionData.type === AgentSessionType.RISK_ASSESSMENT) {
        return 'nist_csf_2_risk_assessment';
      }
      break;

    case AGENT_TYPES.QUESTIONNAIRE:
      return 'qa_filler';
      

    default:
      return 'nist_ai_rmf';
  }
  return 'nist_ai_rmf';
};

export const useAgentSocket = () => {
	const emitControlEdit = async (
		fileUrl: string,
		control: any,
		controlId: string | any,
		agentId: string,
		stepId: string,
		editedField: string,
	) => {
		try {
			const socket = getZaniaSocket();
			const token = await getSessionJWT();
			const agentData = getAgentData(agentId);
   			if (!agentData) return;

			socket.emit(
				AgentSocketEvents.CONTROL_EDIT,
				{
					file_url: fileUrl,
					control,
					...(control.section === VendorRiskSectionEnum.vendor_overview
						? { control_key: controlId }
						: { control_id: controlId }),
					agent_session_id: agentId,
					agent_session_step_id: stepId,
					field: editedField,
					task: getAgentTask(agentData),
				},
				(error: Error) => {
					if (error) {
						console.error("Socket emit error:", error);
					} 
				},
			);
		} catch (error) {
			console.error("Error in emitControlEdit:", error);
			throw error;
		}
	};

  return { emitControlEdit };
};
